module.exports = __webpack_public_path__ + "8ebdd96622429b4fe475fa3e6583bd88.svg";